export const GUIDE_PATH = '/guide';
export const isGuidePath = (value) => /^\/guide(?:\/[a-z0-9]+(?:-[a-z0-9]+)*)*\/?(?:#[a-z0-9]+(?:-[a-z0-9]+)*)?$/.test(value);
/** Resolve published guide paths against this client's service, never the embedding application's host. */
export function guideCitationUrl(path, serviceBaseUrl) {
    if (!isGuidePath(path))
        return null;
    try {
        const base = new URL(serviceBaseUrl);
        if (!['http:', 'https:'].includes(base.protocol) || base.username || base.password || base.search || base.hash)
            return null;
        const loopback = base.hostname === 'localhost' || base.hostname === '[::1]' || /^127(?:\.\d{1,3}){3}$/.test(base.hostname);
        if (base.protocol === 'http:' && !loopback)
            return null;
        return new URL(path, base.origin).toString();
    }
    catch {
        return null;
    }
}
export function guideAppearance(preferences) {
    return { theme: preferences.theme, accent: preferences.accent, font: preferences.chatFont };
}
/** The native host constructs its confined URL; web hosts use their configured Gyro service. */
export function openUserGuide(appearance, section = '', serviceBaseUrl = '') {
    const safeSection = /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(section) && section.length <= 96 ? section : '';
    const handled = !window.dispatchEvent(new CustomEvent('gyro:guide-open', {
        detail: { ...appearance, section: safeSection }, cancelable: true,
    }));
    if (handled)
        return;
    const target = guideCitationUrl(GUIDE_PATH + (safeSection ? `/${safeSection}` : ''), serviceBaseUrl);
    if (!target)
        return;
    const url = new URL(target);
    url.search = new URLSearchParams(appearance).toString();
    window.open(url.toString(), '_blank', 'noopener,noreferrer');
}
//# sourceMappingURL=userGuide.js.map